import { IProduct } from 'interfaces/product'
import { createContext } from 'react'

export const ProductContext = createContext<IProduct | undefined>(undefined)
